import {zoomService} from "@/modules/zoom/services/zoomService";

export const zoomAuthorize = () => {
  return new Promise(async (resolve, reject) => {
    const res = await zoomService.authorize()
    if (res.authorized || res === 'window-closed') {
      resolve(res)
    } else {
      reject(res)
    }
  })
}

export const zoomDisconnect = () => {
  return new Promise(async (resolve) => {
    resolve(await zoomService.disconnect())
  })
}

export const getConnectedDetails = () => {
  return new Promise((resolve) => {
    resolve(zoomService.getConnectedDetails())
  })
}
